module.exports = __webpack_public_path__ + "img/project9_19.png.6fd0d153.webp";